import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { ShieldCheck } from "lucide-react";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords do not match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset successful. Please log in.");
      navigate("/login");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-10 w-10 rounded-md bg-primary flex items-center justify-center"><ShieldCheck className="h-5 w-5 text-white" /></div>
          <p className="font-heading font-bold">Reset Password</p>
        </div>
        {!token ? (
          <p className="text-sm text-destructive">Invalid reset link.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div><Label>New Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" data-testid="reset-password-input" /></div>
            <div><Label>Confirm Password</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="mt-1.5" data-testid="reset-confirm-input" /></div>
            <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit-btn">Reset Password</Button>
          </form>
        )}
      </div>
    </div>
  );
}
